import { InternalChatFormValues } from "@/pages/InternalChats/interfaces/internalChatFormValues";
import { dayOptions, frequencyOptions, sendingOptions } from "@/pages/InternalChats/constants/options";
import { t } from "i18next";

export const internalChatFormValues: InternalChatFormValues = {
    title: "",
    richValue: "",
    from: null,
    assign_to: null,
    type_reaction: null,
    set: null,

    gender: [],
    training_plan: [],
    nutrition_plan: [],
    send_option: 1,
    trigger_type: {id: 1,name: t("posts-master.views.trigger_type.event")},
    event_type: { id: 1, name: "Cumpleaños" },
    groups: [],
    specialists: [],
    categories: [],
    sending: sendingOptions[0],
    days: dayOptions[0],
    frequency: frequencyOptions[0],
    selected_days: [],
    date_start: null,
    date_end: null,
    hour: null,
    min_age: null,
    max_age: null,
    nro_day_assistance: null,
    nro_days_payment: null,
    bonds:[],
    slotsBonds:[],
    number_days: null,
    send: 1,
    state: 'scheduled'
};